// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wQbk","placeholdersHeader":"styles_placeholdersHeader__15Idj","editorStyle":"styles_editorStyle__1909e","placeholdersBox":"styles_placeholdersBox__rkKDI"};